module.exports = __webpack_public_path__ + "img/gmail.ef041f1a.jpg";